








import { Component, mixins } from '@niknevis/vue-modules'
import { FilterEntitySearchMixin } from '@/modules/common/filter/mixins/filterEntitySearchMixin'
import AdminUserSearch from '@/modules/user/components/admin/AdminUserSearch.vue'

@Component({
  components: {
    AdminUserSearch
  }
})
export default class AdminUserSearchFilter extends mixins(FilterEntitySearchMixin) {
}
